/**
 * https://en.wikipedia.org/wiki/Linear_interpolation
 */
export function lerp(a: number, b: number, factor: number) {
  return a + factor * (b - a)
}
